import { IFetchConfig } from "@/lib/http/interfaces/IFetchConfig"

export interface IDepictClientConfig extends IFetchConfig {}

const depictApiBaseUrl = process.env.DEPICT_API_BASE_URL || "https://api.depict.ai/v3"

export const depictConfigFactory = (
    config: { baseUrl: string } = { baseUrl: "" }
): IDepictClientConfig => ({
    baseUrl: config.baseUrl
})

export const depictClientConfig: IFetchConfig = depictConfigFactory({
    baseUrl: depictApiBaseUrl
})
